import { render } from "./UiPropHidden.vue?vue&type=template&id=6861df9a"
import script from "./UiPropHidden.vue?vue&type=script&lang=js"
export * from "./UiPropHidden.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__